










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import IdrLeftNav from "../../components/left-nav.vue";
import SizhenPatients from "./sizhen-patients.vue";
@Component({
  components: {
    MainHeader,
    IdrLeftNav,
    SizhenPatients
  }
})
export default class IdrPatientList extends Vue {}
